import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostResetPasswordRequest = {
	token: string;
	newPassword: string;
};

export const postResetPassword = createPostEndpoint<PostResetPasswordRequest, string>(
	'/api/v3/security/authentication/reset-password'
);
